import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { Flex } from '@oracle/oraclejet-preact/UNSAFE_Flex';

describe('Test Flex component', () => {
  it('render', async function () {
    const content = render(<Flex>Text</Flex>);
    const sampleText = await content.findByText('Text');
    expect(sampleText).not.null;
  });
});
